var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":"Race Lens","height":"12","src":require("@/assets/images/logo.svg"),"width":"32"}})
}
var staticRenderFns = []

export { render, staticRenderFns }